import React, { useState } from "react";
import {
  AUDIT_API_LOG_URL,
    SOURCE_FETCH_URL,
    
  } from "../../../configs/constants";
import Table from "components/Table";
import Filter from "@Components/Filter";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import * as Yup from "yup";
import eightAxios from "../../../configs/axiosConfig";
import { useNotifyContext } from "components/Notify";
import FileDownload from "js-file-download";


let model = [
    { id: "erml_data_push_date", label: " API Date Time", type: "date_time_origin" },
    { id: "source", label: "Source", type: "objectname", order: "name" },
    { id: "entity_type", label: "Entity type", type: "string" },
    { id: "total", label: "Total", type: "string" },
    { id: "success_count", label: "Success Count", type: "string" },
    { id: "time_taken_for_completion", label: "Time taken for completion (s)", type: "string" },
    { id: "status", label: "Status", type: "string" },
    


];




const filterInitialValues = {
  erml_data_push_date: null,
    source: "",
 
};

const AuditLogApi = () => {
  const [filterValues, setFilterValues] = useState({});
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [downloadId, setDownloadId] = useState([]);

  const actions = [
    {
      type: "export",
      title: "Download",
      icon: <CloudDownloadIcon style={{ color: "red" }} />,
      onClick: (config,data) => downloadLedger(config,data),
    },
  ];
  const filterFields = [
    {
      type: "datepicker",
      label: "API Date",
      name: "erml_data_push_date",
      emptyLabel: "DD/MM/YYYY",
      required:true,

      
    },
   
    {
      type: "reactselect",
      name: "source",
      label: "Source",
      proxyUrl: SOURCE_FETCH_URL,
      paginated: true,
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },

      
    },
    {
        type: "reactselect",
        label: "Entity Type",
        name: "entity_type",
        outerOptions: [
          { id: "Back Office", name: "Back Office" },
          { id: "WORKERS", name: "WORKERS" },
          { id: "WORKER GROUPS", name: "WORKER GROUPS" },
          { id: "User Status Update", name: "User Status Update" },


          
        ],
      },
      {
        type: "reactselect",
        label: "Status",
        name: "status",
        outerOptions: [
          { id: "COMPLETED", name: "COMPLETED" },
          { id: "Failed", name: " Failed" },
          { id: "In Progress", name: "In Progress" },
          { id: "PARTIALLY COMPLETED", name: "PARTIALLY COMPLETED" },

          
        ],
      },
    
   
  
    
    
  ];
  const setNotify = useNotifyContext();
  const downloadLedger = (id) => {
    eightAxios.get(AUDIT_API_LOG_URL + "export/?id=" + id, { responseType: 'blob' })
      .then((response) => {
        const contentDisposition = response.headers['content-disposition'];
        let fileName = 'file.zip';
  
        if (contentDisposition) {
          const match = contentDisposition.match(/filename=(.*)/);
          if (match && match[1]) {
            fileName = match[1];
          }
        }
          const downloadLink = document.createElement('a');
        const url = window.URL.createObjectURL(response.data);
  
        downloadLink.href = url;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
  
        setNotify({
          isOpen: true,
          message: "Download successful",
          type: "success",
        });
      })
      .catch((error) => {
        if(error.response.status === 500){
          setNotify({
            isOpen: true,
            message: "Failed to write the file. Please try again later!",
            type: "error",
          });
        }else{
          setNotify({
            isOpen: true,
            message: error.response ? error.response.data.message : "An error occurred",
            type: "error",
          });
        }
      });
  };
  
  
  const validationSchema = Yup.object({
  
    erml_data_push_date: Yup.string()
      .required("API date is required")
      .typeError("Invalid API date"),
   
  });
  const onFilterRequest = (values) => {
    setFiltersApplied(true);

    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };
  const clearFilter =()=>{
    filterInitialValues.status = null
    location.reload();
   }
  

  return (
    <>
      <Filter
        filterFields={filterFields}
        initialValues={filterInitialValues}
        onSubmit={onFilterRequest}
        validationSchema={validationSchema}
        onClear={clearFilter}



      />
            {filtersApplied ? (

      <Table
        proxyURL={AUDIT_API_LOG_URL}
        model={model}
        exportUrl="url"
        filterValues={filterValues}
        noFilter
        actions={actions}

        noAddButton
      />
      ) : (

        <Table
        proxyURL={null}
        model={model}
        exportUrl="url"
        filterValues={filterValues}
        noFilter
        actions={actions}

        noAddButton
      />
      )}
    </>
  );
};
export default AuditLogApi;
